import type { IAddressAdapter } from "@/domains/address/adapters/address-adapter.ts";
import type { TGovernmentNormalizedAddress } from "@/domains/address/dto/normalized-address.ts";
import type { FrenchGovernmentAddress } from "@/domains/address/providers/french-government/french-government-address.ts";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types.ts";

import { gouvFeatureToAddressSuggestion } from "../providers/french-government/french-government-address-provider";

export const FrenchGovernmentAddressToNormalizedAddressAdapter: IAddressAdapter<
  FrenchGovernmentAddress,
  TGovernmentNormalizedAddress
> = {
  adapt(address: FrenchGovernmentAddress): TGovernmentNormalizedAddress {
    const rawFeature = address.getRaw();
    const suggestion = gouvFeatureToAddressSuggestion(rawFeature);

    return {
      raw: rawFeature,
      data: {
        streetNumber: suggestion.streetNumber,
        street: suggestion.street,
        postalCode: suggestion.postalCode,
        cityCode: suggestion.cityCode,
        city: suggestion.city,
      },
      provider: EAddressProvider.FRENCH_GOVERNMENT,
    };
  },
};
